var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mayViewZone)?_c('router-link',{attrs:{"to":{name: 'zone.view.version', params: {vid: _vm.vid}}},domProps:{"textContent":_vm._s(_vm.zoneId || _vm.vid)}}):_c('span',[_vm._v(" "+_vm._s(_vm.zoneId || _vm.vid)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }